import React from "react";
import { Route } from "react-router-dom";

import Tabs from "../../components/Tabs";

import EMPsList from "./components/EMPsList";
import { CUSTOMER_TABS } from "./consts";

const EmpsPage: React.FC = () => {
  return (
    <Tabs
      tabs={CUSTOMER_TABS}
      activeRoute={<Route path="/" element={<EMPsList />} />}
    />
  );
};

export default EmpsPage;
